import { render, staticRenderFns } from "./editAssetBrand.vue?vue&type=template&id=21bb23da&scoped=true"
import script from "./editAssetBrand.vue?vue&type=script&lang=js"
export * from "./editAssetBrand.vue?vue&type=script&lang=js"
import style0 from "./editAssetBrand.vue?vue&type=style&index=0&id=21bb23da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb23da",
  null
  
)

export default component.exports